"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG_TYPES = void 0;
// definition
var LOG_TYPES = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'];
exports.LOG_TYPES = LOG_TYPES;